import React from 'react';
import { StyleSheet, View, Text, TouchableHighlight } from '../base_components';

export const styles = StyleSheet.create({
  textButton: {
    height: '2rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    overflow: 'visible',
  },
  inner: {
    paddingLeft: '2rem',
    paddingRight: '2rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: '#262626',
    fontSize: '1.3rem',
    fontWeight: '500',
  },
  defaultButton: {
    backgroundColor: 'white',
    boxShadow: '0px 1px 2px rgba(0,0,0,0.3)',
  },
  disabledButton: {
    backgroundColor: 'white',
    boxShadow: '0px 1px 2px rgba(0,0,0,0.2)',
  },
  disabledText: {
    color: '#bfbfbf',
  },
  blackButton: {
    backgroundColor: 'black',
  },
  ghostInvertedButton: {
    borderColor: 'white',
    borderWidth: 1,
    backgroundColor: 'transparent',
  },
  ghostInvertedText: {
    color: 'white',
  },
  ghostButton: {
    borderColor: '#262626',
    borderWidth: 1,
    backgroundColor: 'transparent',
  },
  ghostText: {
    color: '#262626',
  },
  emptyButton: {
    backgroundColor: 'transparent',
  },
  blackText: {
    color: '#262626',
  },
  whiteText: {
    color: 'white',
  },
  highlight: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: '0.5rem',
    overflow: 'hidden',
  },
  redText: {
    color: 'red',
  },
});

export function getButtonStyles(props) {
  const { disabled, type } = props;
  let button_extra: any = styles.defaultButton;
  let text_extra: any = styles.blackText;
  if (disabled) {
    button_extra = styles.disabledButton;
    text_extra = styles.disabledText;
  } else if (type === 'ghost') {
    button_extra = styles.ghostButton;
    text_extra = styles.ghostText;
  } else if (type === 'ghost-inverted') {
    button_extra = styles.ghostInvertedButton;
    text_extra = styles.ghostInvertedText;
  } else if (type === 'empty') {
    button_extra = styles.emptyButton;
    text_extra = styles.blackText;
  } else if (type === 'inverted') {
    button_extra = styles.blackButton;
    text_extra = styles.whiteText;
  } else if (type === 'danger') {
    button_extra = styles.defaultButton;
    text_extra = styles.redText;
  }
  return { button_extra, text_extra };
}

type Props = {
  style?: any;
  textStyle?: any;
  type?: any;
  text: string;
  disabled?: boolean;
  onPress?: () => void;
  underlayColor?: string;
  beforeText?: any;
  afterText?: any;
  isBusy?: boolean;
};
export default function TextButton(props: Props) {
  const {
    style,
    textStyle,
    text,
    disabled,
    onPress,
    underlayColor,
    beforeText,
    afterText,
  } = props;
  const { button_extra, text_extra } = getButtonStyles(props);

  return (
    <View style={[styles.textButton, button_extra, style]}>
      <View style={styles.inner}>
        {beforeText}
        <Text style={[styles.text, text_extra, textStyle]}>{text}</Text>
        {afterText}
      </View>
      {disabled ? null : (
        <TouchableHighlight
          style={styles.highlight}
          underlayColor={underlayColor || 'rgba(0,0,0,0.2)'}
          onPress={onPress}
        >
          <View style={StyleSheet.absoluteFill} />
        </TouchableHighlight>
      )}
    </View>
  );
}
